import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import StkRcpt03Actions, { StkRcpt03Types } from '../Stores/StkRcpt03/Actions';

const getAppStore = state => state.app;

export function* stkRcpt03FetchStkRcpt03({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(StkRcpt03Actions.stkRcpt03FetchStkRcpt03Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `stkRcpt/indexProcess/STK_RCPT_03/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        StkRcpt03Actions.stkRcpt03FetchStkRcpt03Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(StkRcpt03Actions.stkRcpt03FetchStkRcpt03Loading(false));
  }
}

export function* stkRcpt03CreateStkRcpt03({ hdrIds, toStorageBinId }) {
  try {
    yield put(StkRcpt03Actions.stkRcpt03CreateStkRcpt03Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds,
      toStorageBinId
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `stkRcpt/createProcess/STK_RCPT_03`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(StkRcpt03Actions.stkRcpt03CreateStkRcpt03Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(StkRcpt03Actions.stkRcpt03CreateStkRcpt03Loading(false));
  }
}

export function* stkRcpt03GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/stkIssDetail/update/${hdrId}`));
}

export const saga = [
  takeLatest(StkRcpt03Types.STK_RCPT03_GO_TO_DOCUMENT, stkRcpt03GoToDocument),
  takeLatest(StkRcpt03Types.STK_RCPT03_FETCH_STK_RCPT03, stkRcpt03FetchStkRcpt03),
  takeLatest(StkRcpt03Types.STK_RCPT03_CREATE_STK_RCPT03, stkRcpt03CreateStkRcpt03)
];
